import getType from '../utils/getType';
import { DATABASE_FIELD, TEXT_PLAIN } from '../../../types/TransferTypes';
export default function onPaste(event, database, next) {
  if (database.selection.isFocused) return next();
  event.preventDefault();
  event.stopPropagation();
  var transfer = event.dataTransfer || event.clipboardData;
  var destination = database.getActive();
  var canEdit = database.run('canEdit', destination.column.type);
  if (!canEdit) return next();
  var rawField = getType(transfer, DATABASE_FIELD);

  if (rawField) {
    var source = JSON.parse(rawField); // No need to convert anything if source column is same as destination

    if (source.column.key === destination.column.key) {
      return database.mergeFieldData(destination.record.key, destination.column.key, source.field.data);
    }

    var data = database.run('convertField', source, destination);

    if (data) {
      return database.mergeFieldData(destination.record.key, destination.column.key, data);
    }
  }

  var rawText = getType(transfer, TEXT_PLAIN);

  if (typeof rawText === 'string') {
    var _data = database.run('convertField', rawText, destination);

    if (_data) {
      return database.mergeFieldData(destination.record.key, destination.column.key, _data);
    }
  }

  return next();
}